<template>
  <v-app>
    <div>
      <v-tabs v-model="tab">
        <v-tab>
          Take Attendance
        </v-tab>
        <v-tab>
          View Attendance
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <v-tab-item

        >
          <div class="card card-custom">
            <div class="card-body p-0">
              <div
                      class="wizard wizard-2"
                      id="kt_wizard_v2"
                      data-wizard-state="step-first"
                      data-wizard-clickable="true"
              >
                <div class="wizard-body py-8 px-8 py-lg-10 px-lg-10">
                  <div class="row">
                    <div class="col-6">
                      <h4>
                        <router-link :to="{name:'students'}">
                          <i class="fas fa-arrow-left"></i>
                        </router-link>
                        Attendance
                      </h4>
                    </div>


                    <v-row class="text-center">
                      <v-col cols="12" class="text-center">

                        <div class="card-body">
                          <v-form class="form" id="kt_password_change_form">
                            <div class="form-group row row bg-filter">

                              <div class="col-lg-2">
                                <v-select
                                        outlined
                                        dense
                                        class="form-control"
                                        v-model="search.timetable_period_id"
                                        :items="academicClassTimetablePeriods"
                                        label="Period Name"
                                        item-value="id"
                                        item-text="subject_name"
                                ></v-select>

                              </div>
                              <div class="col-lg-2">
                                <v-menu
                                        ref="menu1"
                                        v-model="menu1"
                                        :close-on-content-click="false"
                                        transition="scale-transition"
                                        offset-y
                                        max-width="290px"
                                        min-width="auto"
                                >
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                            v-model="search.date"
                                            label="Date"
                                            persistent-hint
                                            outlined
                                            dense
                                            v-bind="attrs"
                                            v-on="on"
                                    ></v-text-field>
                                  </template>
                                  <v-date-picker
                                          v-model="search.date"
                                          no-title
                                          @input="menu1 = false"
                                  ></v-date-picker>
                                </v-menu>

                              </div>

                              <div class="col-lg-2">
                                <button
                                        @click.prevent="getStudentAttendance"
                                        type="submit"
                                        class="form-control  btn btn-primary "
                                        name="search"
                                        ref="search"
                                >Search
                                </button>
                              </div>
                              <div class="col-lg-2">
                                <button
                                        class="form-control fbtn btn-standard "
                                        @click.prevent="resetFilter"

                                >Reset
                                </button>
                              </div>


                            </div>
                          </v-form>
                        </div>

                      </v-col>
                      <v-col cols="12" v-if="selected.length>0">
                        <v-card flat color="grey lighten-4">
                          <v-toolbar flat color="grey lighten-4">
                            <v-toolbar-title>Total Selected : {{ selected.length }}
                            </v-toolbar-title>
                            <v-toolbar-title class="ml-5"> Actions :</v-toolbar-title>

                            <v-radio-group row v-model="attendance"
                                           @change="setAllAttendance()">

                              <v-radio value="p">
                                <template v-slot:label>
                                  Present
                                </template>
                              </v-radio>
                              <v-radio value="a">
                                <template v-slot:label>
                                  Absent
                                </template>
                              </v-radio>
                              <v-radio value="pl">
                                <template v-slot:label>
                                  Late
                                </template>
                              </v-radio>
                              <v-radio value="ph">
                                <template v-slot:label>
                                  Half Day
                                </template>
                              </v-radio>
                            </v-radio-group>

                            <v-btn @click="saveAttendance()" depressed
                                   class=" btn btn-primary text-white">
                              SAVE
                            </v-btn>
                          </v-toolbar>
                        </v-card>

                      </v-col>
                    </v-row>
                    <div class="col-12">
                      <table class="table table-stripe">
                        <thead>
                        <th>
                          <v-checkbox @change="selectAll()" v-model="checkAll" outlined dense
                                      label="Full Name"></v-checkbox>
                        </th>
                        <th>Image</th>
                        <th>Symbol Number</th>
                        <th> Attendance</th>
                        <th>Remark</th>
                        </thead>
                        <tbody>
                        <tr v-for="(user, index) of users" :key="index">
                          <td>
                            <v-checkbox v-model="selected" :value="user.student_id" outlined
                                        dense
                                        v-bind:label="(user.full_name)?user.full_name:null"></v-checkbox>
                          </td>
                          <td>
                            <div class="symbol-label">
                              <img v-if="user.photo"
                                   :src="user.image_path.thumb"
                                   class="cursor-pointer" alt=""
                                   @click="changeImage(user)"
                                   style="height: 30px;">
                              <span v-else class="symbol symbol-35 symbol-light-success">
                                                    <span
                                                            class="symbol-label font-size-h5 font-weight-bold cursor-pointer"
                                                            @click="changeImage(user)"> {{
                                                        (user.full_name) ? user.full_name.charAt(0) : null
                                                      }} </span>
                                                </span>
                            </div>
                          </td>

                          <td>{{ user.setting ? user.setting.symbol_no : "N/A" }}
                          </td>
                          <td>
                            <v-radio-group row v-model="user.attendance"
                                           @change="setAttendance(index)">

                              <v-radio value="p">
                                <template v-slot:label>
                                  Present
                                </template>
                              </v-radio>
                              <v-radio value="a">
                                <template v-slot:label>
                                  Absent
                                </template>
                              </v-radio>
                              <v-radio value="pl">
                                <template v-slot:label>
                                  Late
                                </template>
                              </v-radio>
                              <v-radio value="ph">
                                <template v-slot:label>
                                  Half Day
                                </template>
                              </v-radio>
                            </v-radio-group>
                          </td>

                          <td>
                            <v-text-field
                                    dense
                                    v-model="user.remark"
                                    outlined
                                    label="Remark"
                            ></v-text-field>
                          </td>


                        </tr>
                        </tbody>
                      </table>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </v-tab-item>
        <v-tab-item>
          <div class="card-body">
            <v-form class="form" id="kt_password_change_form">
              <div class="form-group row bg-filter">


                <div class="col-lg-2">
                  <v-select
                          outlined
                          dense
                          class="form-control"
                          v-model="search.timetable_period_id"
                          :items="academicClassTimetablePeriods"
                          label="Period Name"
                          item-value="id"
                          item-text="subject_name"
                  ></v-select>

                </div>
                <div class="col-lg-2">
                  <v-select
                          outlined
                          dense
                          class="form-control"
                          v-model="search.month"
                          :items="monthNames"
                          label="Month"
                          item-value="value"
                          item-text="name"
                  ></v-select>


                </div>

                <div class="col-lg-2">
                  <button
                          @click.prevent="getReport"
                          type="submit"
                          class="form-control  btn btn-primary "
                          name="search"
                          ref="search"
                  >Search
                  </button>
                </div>
                <div class="col-lg-2">
                  <button
                          class="form-control fbtn btn-standard "
                          @click.prevent="resetFilter"

                  >Reset
                  </button>
                </div>


              </div>
            </v-form>
          </div>
          <v-card v-if="attendanceReports.report">
            <v-card-title>
              Attendance Report  <span class="ml-2" v-if="attendanceReports"> {{` of ${attendanceReports.month_name}, ${attendanceReports.year} - ${attendanceReports.subject}  `}}</span>
            </v-card-title>
            <v-card-text>
              <table>
                <tr>
                  <th class="text-center">{{attendanceReports.month_name}}</th>
                  <th class="text-center" colspan="4"> Total</th>
                  <th class="text-center" v-for="day in attendanceReports.end_to" :key="day">{{`${days[new
                    Date(search.year, search.month -1,
                    day).getDay()]}`}}
                  </th>
                </tr>
                <tr>
                  <th class="text-center">Name</th>
                  <th class="text-center"> Present</th>
                  <th class="text-center"> Absent</th>
                  <th class="text-center"> Late</th>
                  <th class="text-center"> Half Day</th>

                  <th style="width: 50px" class="text-center" v-for="day in attendanceReports.end_to">
                    {{day}}
                  </th>
                </tr>
                <tr v-for="(student,index) in attendanceReports.report">
                  <td style="width: 330px" class=" pl-1">
                    {{student.full_name}}
                  </td>
                  <td class="text-center" style="width: 80px">
                    {{student.total_present}}
                  </td>
                  <td class="text-center" style="width: 80px">
                    {{student.total_absent}}
                  </td>
                  <td class="text-center" style="width: 80px">
                    {{student.total_late}}
                  </td>
                  <td class="text-center" style="width: 80px">
                    {{student.total_half_day}}
                  </td>
                  <td v-for="(day, key) in student.attendance_all" @click="status(index, day)"
                      :style="{backgroundColor: getColor(day[key+1])}" class="text-center text-white">
                    {{ getAttendanceDay(day[key+1])}}
                  </td>
                </tr>
              </table>
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs-items>

    </div>
  </v-app>

</template>
<script>
  import UserService from "@/core/services/user/UserService";
  import ProgramService from "@/core/services/level/program/ProgramService";
  import GradeLevelService from "@/core/services/gradeLevel/GradeLevelService";
  import AcademicYearService from "@/core/services/academicYear/AcademicYearService";
  import AcademicClassService from "@/core/services/academic-class/AcademicClassService";
  import LevelService from "@/core/services/level/LevelService";
  import IdCardService from "@/core/services/IdCard/IdCardService";
  import PrinterService from "@/core/services/printer/PrinterService";
  import {required} from "vuelidate/lib/validators";
  import AttendanceService from "@/core/services/attendance/AttendanceService";
  import AcademicCLassTimetableService from "@/core/services/academicClassTimetable/AcademicCLassTimetableService";
  import AcademicCLassTimetablePeriodService
    from "@/core/services/academicClassTimetablePeriod/AcademicCLassTimetablePeriodService";

  const academicCLassTimetablePeriod = new AcademicCLassTimetablePeriodService();

  const academicClassTimetable = new AcademicCLassTimetableService();
  const attendance = new AttendanceService();
  const idCardService = new IdCardService();
  const userService = new UserService();
  const programService = new ProgramService();
  const gradeLevelService = new GradeLevelService();
  const academicClassService = new AcademicClassService();
  const academicYearService = new AcademicYearService();
  const levelService = new LevelService()

  const printerService = new PrinterService();
  export default {
    name: "users",
    components: {},
    validations: {
      new_id_card: {
        print_id: {required},
        file_name: {required}
      }
    },
    data() {
      var d = new Date(),
              month = d.getMonth(),
              year = d.getYear();
      return {
        employee: {
          name: ''
        },
        month: month,
        year: year,
        employees: [
          {
            name: 'lorem ipsum'
          }
        ],
        no_of_days: new Date(year, month + 1, 0),
        days: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        monthNames: [
          {
            name: "January",
            value: 1,
          },
          {
            name: "February",
            value: 2,
          },
          {
            name: "March",
            value: 3,
          },
          {
            name: "April",
            value: 4,
          },
          {
            name: "May",
            value: 5,
          },
          {
            name: "June",
            value: 6,
          }, {
            name: "July",
            value: 7,
          }, {
            name: "August",
            value: 8,
          }, {
            name: "September",
            value: 9,
          },
          {
            name: "October",
            value: 10,
          }, {
            name: "November",
            value: 11,
          }, {
            name: "December",
            value: 12,
          },
        ],
        tab: null,
        dob_bs: null,
        checkAll: false,
        isLoading: false,
        dialog: false,


        attendance: null,
        isBusy: false,
        menu1: false,

        students: [],
        academicClassTimetables: [],
        academicClassTimetablePeriods: [],

        date: new Date().toISOString().substr(0, 10),
        search: {
          // date: null,
          academic_class_id: null,
          // time_table_id: null,
          // timetable_period_id: null,

          // academic_class_id: 33,
          // time_table_id: 1,
          day_attendance: false,
          timetable_period_id: "",
          // level_id: 3,
          // program_id: 7,
          // academic_year_id: 5,
          year: 2021,
          month: 5,
          // grade_id: 4
        },
        attendanceReports: [],
        users: [],
        selected: [],
        studentList: [],
      };
    },
    computed: {
      currentUser() {
        return this.$store.getters.currentUser;
      },
      classId() {
        return this.$route.params.classId;
      },
    },
    mounted() {
      if (this.$route.query.first_name) {
        this.search = this.$route.query;
      }

      this.getLevels();
      this.getAcademicTimetablePeriod();
    },
    methods: {
      status(index, day) {
        this.users[index][day] = !this.users[index][day]
        this.$set(this.users, index, this.users[index])
      },
      setAttendance(index) {
        switch (this.users[index].attendance) {
          case 'p' :
            this.users[index].present = 1;
            this.users[index].late = 0;
            this.users[index].half_day = 0;
            break;
          case 'a' :
            this.users[index].present = 0;
            this.users[index].late = 0;
            this.users[index].half_day = 0;
            break;
          case 'pl' :
            this.users[index].present = 1;
            this.users[index].late = 1;
            this.users[index].half_day = 0;
            break;
          case 'ph' :
            this.users[index].present = 1;
            this.users[index].late = 0;
            this.users[index].half_day = 1;
            break;
          default:
            this.users[index].present = 0;
            this.users[index].late = 0;
            this.users[index].half_day = 0;
            break;
        }
      },
      setAllAttendance() {
        let present = null;
        let half_day = null;
        let late = null;
        switch (this.attendance) {
          case 'p' :
            present = 1;
            break;
          case 'a' :
            present = 0;
            break;
          case 'pl' :
            present = 1;
            late = 1;
            break;
          case 'ph' :
            present = 1;
            half_day = 1;
            break;
          default:
            present = 0;
            break;
        }
        this.users.forEach((user) => {
          user.attendance = this.attendance;
          user.present = present;
          user.half_day = half_day;
          user.late = late;
        })
      },
      formatDate() {
        return this.class.start_date.split('/').join('-');
      },
      getReport() {
        let month = this.search.month;
        this.search.academic_class_id = this.classId;
        this.search.month = this.search.month.toLocaleString('en-US', {//this is the function that formats the numbers
          minimumIntegerDigits: 2, //change this to your minimum length
          useGrouping: false
        });
        attendance.getReport(this.search).then(response => {
          this.attendanceReports = response.data;
        });
        this.search.month = month;
      },

      resetFilter() {
        this.search = {
          first_name: '',
          last_name: '',
          phone: '',
          email: '',
          academic_year_id: '',
          level_id: '',
          program_id: '',
          grade_id: '',
          class_id: '',
          type: 'student',
          limit: 80
        }
        this.users = [];
        // this.getUsers();


      },
      changeImage(user) {
        this.user = user;
        this.uploadDialog = true;
      },
      addStudents() {
        this.selected.forEach((student) => {
          if (this.studentList.indexOf(student) === -1) {
            this.studentList.push(student);
          }
        })

      },
      removeStudentFromList(index) {
        this.$confirm({
          message: `Are you sure?`,
          button: {
            no: "No",
            yes: "Yes"
          },
          /**
           * Callback Function
           * @param {Boolean} confirm
           */
          callback: confirm => {
            if (confirm) {
              this.studentList.splice(index, 1);
            }
          }
        });

      },

      getAcademicTimetablePeriod() {
        academicCLassTimetablePeriod.getByClassAndTeacherId(this.classId,this.currentUser.id).then((resources) => {
          this.academicClassTimetablePeriods = resources.data.academicClassTimetablePeriod;
        }).catch(err => {
          // console.log(err)
        })
      },
      getStudentAttendance() {
        // console.log(this.search)
        this.search.academic_class_id = this.classId;
        attendance.getStudentAttendance(this.search).then(response => {
          this.users = response.data
        })
      },
      saveIds() {
        this.$v.new_id_card.$touch();
        if (this.$v.new_id_card.$error) {
          setTimeout(() => {
            this.$v.new_id_card.$reset();
          }, 3000);
        } else {
          if (this.studentList.length > 0) {
            this.studentList.forEach((student) => {
              this.studentCards.push({
                user_id: student.id,
                expiry_date: this.expiryDate,
                issue_date: this.date,
                issued_by: this.currentUser.id,
                printer_id: this.new_id_card.print_id,
                file_name: this.new_id_card.file_name,
              });
            })
          } else {
            this.selected.forEach((student) => {
              this.studentCards.push({
                user_id: student.id,
                expiry_date: this.expiryDate,
                issue_date: this.date,
                issued_by: this.currentUser.id,
                printer_id: this.new_id_card.print_id,
                file_name: this.new_id_card.file_name,
              });
            })
          }
          idCardService.store(this.studentCards).then((res) => {
            this.studentList = [];
            this.studentCards = [];
            this.isBusy = false;
            this.$bus.emit('checkNotification',);
            this.$snotify.success("Updated successfully");
            this.new_id_card.print_id = '';
            this.new_id_card.file_name = '';
            this.expiryDate = '';
            this.dialog = false;
            this.getUsers();
          })
        }


      },

      getTimeTable() {
        academicClassTimetable.getByClass(this.search.academic_class_id).then((response) => {
          this.academicClassTimetables.push(response.data.academicClassTimetable);
          this.getAcademicTimetablePeriod();
        })
      },
      selectAll() {
        if (!this.checkAll) {
          this.selected = [];
        } else {
          this.users.forEach(user => {
            this.selected.push(user.student_id);
          })

        }
      },


      editUser(id) {
        return this.$router.push({name: "students-update", params: {id: id}});
      },
      getLevels() {
        levelService.all().then(response => {
          this.levels = response.data;
          if (this.search.id && this.search.level_id) {
            this.getPrograms();
          }
        });
      },
      getPrograms() {
        programService.getAllByLevelId(this.search.level_id).then(response => {
          this.programs = response.data;
        });
      },
      getAcademicYears() {
        academicYearService.all().then(response => {
          this.academicYears = response.data;

        });
      },
      getSelected() {
        let selected = []
        this.selected.forEach(studnet_id => {
          this.users.forEach(user => {
            if (studnet_id == user.student_id) {
              selected.push(user)
            }
          })
        })
        return selected;
      },
      getColor(value) {
        switch (value) {
          case 'n' :
            return 'lightgray';
            break;
          case 'a' :
            return 'red';
            break;
          case 'p' :
            return 'green';
            break;
          case 'ph' :
            return 'orange';
            break;
          case 'pl' :
            return 'orange';
            break;
          default:
            return ;'white';

        }
      },
      getAttendanceDay(value) {
        switch (value) {
          case 'n' :
            return ' ';
            break;
          case 'a' :
            return 'A';
            break;
          case 'p' :
            return 'P';
            break;
          case 'ph' :
            return 'H';
            break;
          case 'pl' :
            return 'L';
            break;
          default:
            return ;'';

        }
      },
      saveAttendance() {
        let selected = this.getSelected()
        attendance.store(selected).then((response) => {
          this.$snotify.success('saved Successfully');
          this.getStudentAttendance()
          this.selected = []
          this.checkAll = false
          this.attendance = null
        }).catch(err => {
          console.log(err)
          this.$snotify.error(err);
        })
      },
      getGrades() {
        gradeLevelService.getByProgram(this.search.program_id).then(response => {
          this.gradesLevels = response.data;

        });
      },
      getAcademicClasses() {
        academicClassService.getByProgramLevel(this.search.academic_year_id, this.search.program_id, this.search.grade_id).then(response => {
          this.academic_classes = response.data;
        });
      },
      deleteUser(id) {
        this.$confirm({
          message: `Are you sure?`,
          button: {
            no: "No",
            yes: "Yes"
          },
          /**
           * Callback Function
           * @param {Boolean} confirm
           */
          callback: confirm => {
            if (confirm) {
              userService
                      .delete(id)
                      .then(response => {
                        this.$snotify.success("Deleted successfully");
                        this.getSlider();
                      })
                      .catch(error => {
                        //console.log(error);
                      });
            }
          }
        });
      },

    }
  };
</script>

<style scoped>
  .form-control {
    border: none !important;
  }

  .bg-filter {
    background-color: #eaeaea !important;
  }

  .attenedance table {
    border-collapse: collapse;
  }

  .attenedance table, th, td {
    border: 1px solid black;
  }
</style>
